import store from "@/store";

export const USER_PERMISSIONS = {
  VIEWER: "VIEWER",
  ADMIN: "ADMIN",
};

export const hasDeviceTenantPermission = (permission) => {
  const tenant = store.state.device.current.owner?.slug;
  const tenantPermission = tenant + ":" + permission;
  return (
    store.getters["auth/isSuperAdmin"] ||
    store.getters["auth/userRoles"].find((userPerm) => userPerm === tenantPermission) !== undefined
  );
};

export const hasRights = (permission) => {
  return store.getters["auth/userRoles"].find((userPerm) => userPerm.includes(permission));
};

export const hasRightsForChosenTenant = (permission, tenantId) => {
  const userRoles = store.getters["auth/userRoles"];
  if (!userRoles || !tenantId ) {
    return false
  }
  const tenantSlug = tenantId.split(':').pop();
  return userRoles.includes(`${tenantSlug}:${permission}`);
};

// Checks if device version is superior to given version
export const hasVersionBelow = (device, version) => {
  if (device && device.firmware && device.firmware.version) {
    const compare = device.firmware.version.localeCompare(version, undefined, { numeric: true, sensitivity: "base" });

    return compare <= 0;
  }
  return true;
};
